import React, { useEffect, useState } from 'react';
import { parseBibtexString, displayPaper, reconstructBibtex } from '../utils/bibtexParser';
import Spinner from '../components/Spinner';
import PublicationsModal from '../components/PublicationsModal';
import '../styles/PublicationsPage.css';

function PublicationsPage() {
    const [publicationsByYear, setPublicationsByYear] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [selectedBibtex, setSelectedBibtex] = useState('');
    const [isModalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        fetch('/papers.bib')
            .then((response) => response.text())
            .then((bibtexData) => {
                const parsedData = parseBibtexString(bibtexData);
                if (parsedData) {
                    const groupedPublications = parsedData.reduce((acc, pub) => {
                        const year = pub.year || 'Unknown';
                        if (!acc[year]) {
                            acc[year] = [];
                        }
    
                        // Use the reconstruct function to build the BibTeX entry
                        const reconstructedBibtex = reconstructBibtex(pub);
                        // console.log("RECONSTRUCTED BIBTEX: ", reconstructedBibtex);

                        acc[year].push({
                            ...pub,
                            bibtex: reconstructedBibtex // Add the reconstructed BibTeX
                        });
                        
                        return acc;
                    }, {});
                    setPublicationsByYear(groupedPublications);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching or parsing BibTeX file:", error);
                setIsLoading(false);
            });
    }, []);
    
    

    const handleShowBibtex = (bibtex) => {
        setSelectedBibtex(bibtex);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    if (isLoading) {
        return <Spinner />;
    }

    return (
        <div className="pub-container">
            <h1 className="publications-title">Publications</h1>
            {Object.keys(publicationsByYear).length === 0 ? (
                <p className="pub-no-data">No publications found.</p>
            ) : (
                Object.keys(publicationsByYear)
                    .sort((a, b) => b.localeCompare(a))
                    .map((year) => (
                        <div key={year} className="pub-year-section">
                            <h2 className="pub-year">{year}</h2>
                            {publicationsByYear[year].map((pub, index) => (
                                <div key={index}>
                                    {displayPaper(pub, handleShowBibtex)}
                                </div>
                            ))}
                        </div>
                    ))
            )}
            <PublicationsModal isOpen={isModalOpen} onClose={handleCloseModal} content={selectedBibtex} />
        </div>
    );
}

export default PublicationsPage;
